import { createContext, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { mainClient } from "../api";

const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState(
    localStorage.getItem("userInfo")
      ? JSON.parse(localStorage.getItem("userInfo"))
      : null
  );
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [itemActive, setItemActive] = useState(
    localStorage.getItem("itemActive")
      ? localStorage.getItem("itemActive")
      : "acceuil"
  );
  const [filterParams, setFilterParams] = useState(
    localStorage.getItem("filterParams")
      ? JSON.parse(localStorage.getItem("filterParams"))
      : {
          id: "",
          nom: "",
          dossierBanque: "",
          dossierClient: "",
          etat: "",
          actionBanque: "",
        }
  );

  // Clear/reset state only
  const clearSession = () => {
    setUser(null);
    setItemActive("");
    setFilterParams({
      id: "",
      nom: "",
      dossierBanque: "",
      dossierClient: "",
      etat: "",
      actionBanque: "",
    });
    localStorage.removeItem("userInfo");
    localStorage.removeItem("itemActive");
    localStorage.removeItem("filterParams");
  };

  // Login:
  const login = async (credentials) => {
    setLoading(true);
    setError("");

    try {
      const response = await mainClient.post(
        "/api/taksit/rest/register",
        JSON.stringify(credentials)
      );
      const userData = response.data;

      // Check if user has required roles
      const hasRequiredRole =
        userData.roles.includes("ROLE_CREDIT_ALSALAM_ADMIN") ||
        userData.roles.includes("ROLE_CREDIT_ALSALAM_OPR") ||
        userData.roles.includes("ROLE_LIVRAISON");

      if (hasRequiredRole) {
        setUser(userData);
        localStorage.setItem("userInfo", JSON.stringify(userData));
      } else if (userData.errorCode) {
        setError(userData.errorMessage || "Login failed");
      } else {
        setError("Vous n'êtes pas autorisé à vous connecter");
      }
    } catch (err) {
      //const errorInfo = handleApiError(err);
      const errorInfo = err.response?.data || {};
      setError(errorInfo.message || "Invalid Username/Password");
    } finally {
      setLoading(false);
    }
  };

  // Logout: clear state, remove localStorage, and navigate to login
  const logout = () => {
    clearSession();
    navigate("/banque/login");
  };

  const contextValue = useMemo(
    () => ({
      user,
      setUser,
      loading,
      setLoading,
      error,
      setError,
      itemActive,
      setItemActive,
      filterParams,
      setFilterParams,
      clearSession,
      login,
      logout,
    }),
    [user, loading, error, itemActive, filterParams]
  );

  return (
    <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>
  );
};

export default UserContext;
